/**
 * 27/10/2026 — the rows the status card holds: every row that needed the person at any point of
 * this review (no match, or a near one to confirm), so one answered a moment ago stays where the
 * eye left it, marked answered, instead of folding away. The review is mounted per country and
 * group, so another country starts its own card.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useRef } from 'react';

import type { MatchKind } from './paste-summary';

interface Kind {
  kind: MatchKind;
  entries: Array<{ key: string; needs: boolean }>;
}

export function useAttention(kinds: Kind[]): (kind: MatchKind, key: string) => boolean {
  const seen = useRef(new Set<string>());
  for (const k of kinds) for (const e of k.entries) if (e.needs) seen.current.add(`${k.kind}:${e.key}`);
  return (kind, key) => seen.current.has(`${kind}:${key}`);
}
